module.exports = {
 /*
  * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
  */
  defaultEasing : function (x) {
    'use strict';

    if(x < 0.5) {
      return Math.pow(x*2, 2)/2;
    }
    return 1-Math.pow((1-x)*2, 2)/2;
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scroll/lib/mixins/smooth.js
 ** module id = 3556
 ** module chunks = 0
 **/